import { MakeCall } from '../createMakeCall';

import { UnitTypePhoto } from '../types/inventory/UnitType';

const getUnitTypePhotos = (makeCall: MakeCall) => (unitTypeId: number) =>
  makeCall<UnitTypePhoto[]>('GET', `/api/v2/unit-type/${unitTypeId}/photos`);
export { getUnitTypePhotos };
